import { Box } from '@chakra-ui/react'
import React, { Component } from 'react'
import classNames from 'classnames'
import './HorizontalChoiceSelector.less'
import { brandColors } from 'shared/basicPalette'

export interface IHorizontalChoiceSelectorOption<T> {
  value: T
  header?: string | React.ReactElement<any>
  description?: string | React.ReactElement<any>
}

export default class HorizontalChoiceSelector<
  T extends unknown
> extends Component<{
  name: string
  onChange: (val: T) => void
  options: IHorizontalChoiceSelectorOption<T>[]
  value?: T
  colorScheme?: 'light' | 'light-gray'
}> {
  static defaultProps = {
    value: null
  }

  render() {
    const { props } = this
    const classes = classNames('HorizontalChoiceSelector', {
      'HorizontalChoiceSelector--light-gray': props.colorScheme === 'light-gray'
    })

    return (
      <ul className={classes}>
        {this.props.options.map((option) => {
          const isSelected = this.props.value === option.value
          return (
            <Box
              as="li"
              border={
                isSelected
                  ? `1px solid var(--chakra-colors-buttonPrimary-default)`
                  : `1px solid ${brandColors.grey['200']}`
              }
              // @ts-expect-error 9/11/2020
              key={option.value}
            >
              <label>
                {option.header && <h3>{option.header}</h3>}
                {option.description}
                <input
                  type="radio"
                  value={option.value as string}
                  name={props.name}
                  checked={isSelected}
                  onChange={() => {
                    this.props.onChange(option.value)
                  }}
                />
              </label>
            </Box>
          )
        })}
      </ul>
    )
  }
}
